/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetCriticalPointDto
 */
export interface GetCriticalPointDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetCriticalPointDto
     */
    infoForExamined: Array<string>;
}

/**
 * Check if a given object implements the GetCriticalPointDto interface.
 */
export function instanceOfGetCriticalPointDto(value: object): value is GetCriticalPointDto {
    if (!('infoForExamined' in value) || value['infoForExamined'] === undefined) return false;
    return true;
}

export function GetCriticalPointDtoFromJSON(json: any): GetCriticalPointDto {
    return GetCriticalPointDtoFromJSONTyped(json, false);
}

export function GetCriticalPointDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCriticalPointDto {
    if (json == null) {
        return json;
    }
    return {
        
        'infoForExamined': json['infoForExamined'],
    };
}

export function GetCriticalPointDtoToJSON(value?: GetCriticalPointDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'infoForExamined': value['infoForExamined'],
    };
}

